<div class="popover-content" [ngClass]="type">
    <div class="w-full popover-container text-center" [innerHTML]="content"></div>
</div>
